import { useNavigate, useSearch } from '@tanstack/react-router';

import type {
  TailoredSupplyAppsFilter,
  TailoredSupplyDomainsFilter,
  TailoredSupplyListFilter,
} from './model';
import {
  parseTailoredSupplyCreateSearch,
  parseTailoredSupplyListSearch,
  serializeTailoredSupplyCreateSearch,
  serializeTailoredSupplyListSearch,
} from './routeSearch';

export function useTailoredSupplyListRouteFilters() {
  const navigate = useNavigate({ from: '/supply/tailored-supply/' });
  const search = useSearch({ from: '/supply/tailored-supply/' });
  const filter = parseTailoredSupplyListSearch(search);
  const update = (next: TailoredSupplyListFilter) => {
    void navigate({ search: serializeTailoredSupplyListSearch(next), replace: true });
  };
  return {
    filter,
    setSearch: (name: string) => {
      update({ ...filter, name, page: 0 });
    },
    setPagination: (page: number, size: number) => {
      update({ ...filter, page: size === filter.size ? page : 0, size });
    },
    setSort: (
      sortProperty: TailoredSupplyListFilter['sortProperty'],
      sortDirection: TailoredSupplyListFilter['sortDirection'],
    ) => {
      update({ ...filter, sortProperty, sortDirection, page: 0 });
    },
  };
}

export function useTailoredSupplyCreateRouteFilters() {
  const navigate = useNavigate({ from: '/supply/tailored-supply/create' });
  const search = useSearch({ from: '/supply/tailored-supply/create' });
  const state = parseTailoredSupplyCreateSearch(search);
  const update = (tab = state.tab, apps = state.apps, domains = state.domains) => {
    void navigate({
      search: serializeTailoredSupplyCreateSearch(tab, apps, domains),
      replace: true,
      // These search-only changes keep the mounted editor and its unsaved values.
      ignoreBlocker: true,
    });
  };
  return {
    ...state,
    setTab: (tab: typeof state.tab) => {
      if (tab === state.tab) return;
      void navigate({
        search: serializeTailoredSupplyCreateSearch(tab, state.apps, state.domains),
        resetScroll: false,
      });
    },
    setApps: (apps: TailoredSupplyAppsFilter) => {
      update(state.tab, apps);
    },
    setDomains: (domains: TailoredSupplyDomainsFilter) => {
      update(state.tab, state.apps, domains);
    },
  };
}
